import React from "react";
import ReactDOM from "react-dom/client";
import "./brand.generated.css";
import "./theme.css";
import "./index.css";
import "./responsive.css";
import "./mobile.css";
import "./theme-dark.css";
import App from "./App";
import { initCapacitor, markNativeDocument } from "./utils/mobile";
import { dispatchPushAction } from "./services/pushNotifications";

markNativeDocument();

// Initialise native Capacitor APIs (SplashScreen hide, StatusBar, etc.).
// Push init runs from AuthContext when a valid JWT + user session exist
// (covers both fresh login and cold-start session restore).
initCapacitor().catch(console.error);

// Web push cold start: the service worker opens `/?ess_push=<data>` when the
// user taps a notification and no app tab was already open (see
// public/firebase-messaging-sw.js). Replay it the same way Capacitor replays
// a terminated-state tap on native (see pushNotifications.js).
(function replayWebPushColdStart() {
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get("ess_push");
    if (!raw) return;

    // URLSearchParams.get() already URI-decodes the value.
    const data = JSON.parse(raw);
    dispatchPushAction({ notification: { data } });

    params.delete("ess_push");
    const search = params.toString();
    window.history.replaceState(
      {},
      "",
      window.location.pathname + (search ? `?${search}` : "") + window.location.hash,
    );
  } catch (err) {
    console.error("[WebPush] Cold start replay failed:", err);
  }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
